import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { DayData } from '../utils/mockData';
interface WeeklyChartProps {
  data: DayData[];
}
export function WeeklyChart({
  data
}: WeeklyChartProps) {
  const chartData = data.map(day => ({
    name: day.dayName,
    'Calories In': day.caloriesIn,
    'Calories Out': day.caloriesOut
  }));
  return <div className="bg-gray-800 rounded-xl p-6 border border-gray-700" data-id="element-65">
      <h2 className="text-xl font-bold text-white mb-6" data-id="element-66">Weekly Progress</h2>
      <ResponsiveContainer width="100%" height={300} data-id="element-67">
        <LineChart data={chartData} data-id="element-68">
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" data-id="element-69" />
          <XAxis dataKey="name" stroke="#9CA3AF" style={{
          fontSize: '12px'
        }} data-id="element-70" />
          <YAxis stroke="#9CA3AF" style={{
          fontSize: '12px'
        }} data-id="element-71" />
          <Tooltip contentStyle={{
          backgroundColor: '#1F2937',
          border: '1px solid #374151',
          borderRadius: '8px',
          color: '#fff'
        }} data-id="element-72" />
          <Legend wrapperStyle={{
          color: '#9CA3AF'
        }} data-id="element-73" />
          <Line type="monotone" dataKey="Calories In" stroke="#10B981" strokeWidth={3} dot={{
          fill: '#10B981',
          r: 4
        }} activeDot={{
          r: 6
        }} data-id="element-74" />
          <Line type="monotone" dataKey="Calories Out" stroke="#3B82F6" strokeWidth={3} dot={{
          fill: '#3B82F6',
          r: 4
        }} activeDot={{
          r: 6
        }} data-id="element-75" />
        </LineChart>
      </ResponsiveContainer>
    </div>;
}